import axios from "axios";
import { getAuth } from "firebase/auth";

// Remove "/api" from VITE_API_URL if it exists to avoid double /api in URLs
const apiUrl = import.meta.env.VITE_API_URL.endsWith("/api")
  ? import.meta.env.VITE_API_URL.slice(0, -4) // Remove trailing "/api"
  : import.meta.env.VITE_API_URL;

export const api = axios.create({
  baseURL: `${apiUrl}/api`, // Ensure consistent /api prefix
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include Firebase auth token
api.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    try {
      const token = await user.getIdToken(true); // Force refresh token
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error("Error getting auth token:", error);
    }
  }

  return config;
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login page on unauthorized
      window.location.href = "/login";
    }
    // Log other errors
    console.error("API Error:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      method: error.config?.method,
      headers: error.config?.headers,
      data: error.response?.data,
    });
    return Promise.reject(error);
  },
);
